// API Data

export interface ICurrencyData {
  id?: number;
  code: string;
  description: string;
}
export interface ICurrencyRateData {
  id?: number;
  currency?: number | ICurrencyData;
  owner?: string;
  rate?: string | number;
  created_at?: string | Date;
}

export interface ICurrencyFieldErrorData {
  code: string[];
  description: string[];
}

export interface ICurrencyRateFieldErrorData {
  currency?: ICurrencyFieldErrorData;
  rate?: string[];
}

// Business Logic Interface
export interface ICurrencyRate extends ICurrencyRateData {
  rate?: number;
  currency?: ICurrency | number;
}

// Business Logic Interface
export interface ICurrency extends ICurrencyData {
  validate(): boolean;
}
export interface ICurrencyFieldError extends ICurrencyFieldErrorData {
  clearErrors(): void;
}

export interface ICurrencyRateFieldError extends ICurrencyRateFieldErrorData {
  currency?: ICurrencyFieldError;
  clearErrors(): void;
}
// Constants - Used for validation
export const CURRENCY_ISO_CODE_LENGTH = 3;
export const CURRENCY_MAX_DESCRIPTION_LENGTH = 16;
